const config = {
  productionMode: true,

  event: {
    title: 'Northwest Queer Contra Camp',
    titleWithYear: 'Northwest Queer Contra Camp 2026', // must match backend config
    location: 'Camp Sealth, Vashon Island, Washington',
    date: 'October 30 - November 1, 2026',
    timezone: 'America/Los_Angeles'
  },

  calendar: {
    title: 'Northwest Queer Contra Camp',
    description: 'https://queercontradance.org',
    location: 'Camp Sealth, Vashon Island, Washington',
    start: '2026-10-30T19:00:00-07:00', // ISO 8601 format
    end: '2026-11-01T15:00:00-07:00' // ISO 8601 format
  },

  contacts: {
    info: 'nwcamp@queercontradance.org',
    tech: 'tech@queercontradance.org',
    // housing: 'housing@queercontradance.org'
  },

  links: {
    info: 'queercontradance.org/nwqueercamp.html',
    policies: {
      covid: 'queercontradance.org/queercamp.html#healthsafetyprecautions',
      safety: 'queercontradance.org/SFBQCD_Values_and_Expectations.pdf'
    }
  },

  nametags: {
    includePronouns: false,
    includeLastName: true
  },

  staticPages: {
    enabled: false,
    components: ['PaymentExplanation'], // These must exist in src/components/Static
  },

  registration: {
    waitlistMode: false,
    showPreregistration: false,
    showWaiver: false,
    admissionQuantityMax: 4,
    fields: { // Order of form fields
      contact: ['first', 'last', 'nametag', 'pronouns', 'email', 'emailConfirmation', 'phone', 'address', 'apartment', 'city', 'state', 'zip', 'country'],
      misc: ['share', 'carpool', 'bedding', 'volunteer', 'housing', 'roommate', 'misc', 'miscComments', 'agreement', 'comments']
    }
  },

  admissions: {
    mode: 'sliding-scale', // sliding-scale|fixed|tiered
    slidingScale: {
      costRange: [125, 999],
      costDefault: 300
    },
    fixed: {
      cost: 200
    },
    tiered: {
      earlybirdCutoff: '2026-11-10', // last day to get early pricing
    }
  },

  payments: {
    processor: 'paypal', // stripe|paypal - also must set in backend config
    paymentDueDate: 'September 30',
    directPaymentUrl: 'www.paypal.com/donate/?hosted_button_id=4VMTYWHL48GXW', // electronic payment option to pay remaining balance after selecting deposit or check payment
    coverFeesCheckbox: true,
    showPaymentSummary: true, // show summary of costs in payment section
    deposit: {
      enabled: false,
      amount: 50 // ignored if disabled
    },
    donation: {
      enabled: false,
      max: 999 // ignored if disabled
    },
    checks: {
      allowed: true, // If false, the below fields are ignored
      showPostalAddress: false, // If false, shows contact email
      payee: 'Example Check Payee Name',
      address: ['Line 1', 'Line 2', 'Line 3', 'Line 4']
    }
  }
};

export default config;